export default {
  version: 'Verzia {version}',
  empty: 'Tu sa zobrazia novinky nových verzií Qmulus.',
  releaseNotes: 'Všetky zmeny vo verzii {version}',
  versions: 'Verzie',
};
